/**
 * `/trips/active?view=…` deep links (the PWA start URL, Help Center "Try it"
 * buttons, feature-tip emails) resolve to the user's current trip, then to
 * the part of it the link names. `overview`, `itinerary` and `map` are views
 * of the trip page; `chat` and `details` are their own trip pages.
 */
const TRIP_QUERY_VIEWS = ['overview', 'itinerary', 'map'];
const TRIP_PAGE_VIEWS: Record<string, string> = { chat: '/chat', details: '/details?tool=details' };

export function withTripViewQuery(path: string, view: string | null): string {
  if (!view) return path;
  // Only a bare `/trips/:id` gets a view; `/trips` and `/new-trip` stay as they are.
  if (!/^\/trips\/[^/?#]+$/i.test(path)) return path;
  const page = TRIP_PAGE_VIEWS[view];
  if (page) return `${path}${page}`;
  if (!TRIP_QUERY_VIEWS.includes(view)) return path;
  return `${path}?view=${encodeURIComponent(view)}`;
}
